import { render, staticRenderFns } from "./TenantCustomers.vue?vue&type=template&id=31cc64e7&scoped=true&"
import script from "./TenantCustomers.vue?vue&type=script&lang=js&"
export * from "./TenantCustomers.vue?vue&type=script&lang=js&"
import style0 from "./TenantCustomers.vue?vue&type=style&index=0&id=31cc64e7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cc64e7",
  null
  
)

export default component.exports